import { combineReducers } from "redux";
import gatewayNameListReducer from "./gateway_name_list_reducer";

const gatewayNameReducer = combineReducers({ gatewayNameList: gatewayNameListReducer });

export default gatewayNameReducer;
